import { createRouter, createWebHistory } from "vue-router";
import Login from "@/components/Login/Login";
import Dashboard from "@/views/Dashboard";
import pages from "./routes";

import { pagePermission } from "@/permissions";
import store from "@/store";
import { trf } from "@/i18n";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/login",
      component: Login,
    },
    {
      // Dashboard is the shell: sidebar, header, notifications, footer. The
      // pages themselves are children rendered into its <router-view>.
      // Bare "/" matches no child, so it shows the empty branded state the
      // panel has always shown after signing in.
      path: "/",
      component: Dashboard,
      meta: { requiresAuth: true },
      children: pages,
    },
    {
      // Anything unrecognised goes home rather than showing a blank shell with
      // no explanation. Old bookmarks from before this table land here.
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    var token = localStorage.getItem("token");
    if (token) {
      store.commit("LOGIN", {
        name: localStorage.getItem("user"),
        status: true,
        token,
        uhash: localStorage.getItem("uhash"),
        utype: localStorage.getItem("utype"),
        recipes_access: localStorage.getItem("recipes_access"),
        invoices_access: localStorage.getItem("invoices_access"),
        vendors_access: localStorage.getItem("vendors_access"),
        stocks_access: localStorage.getItem("stocks_access"),
      });
      // A page this person's role may not open: send them home instead of
      // showing a shell that fails on its first request. Only when the API has
      // told us their permissions; before that, nothing is restricted.
      const perms = store.state.rbac && store.state.rbac.me.permissions;
      const need = pagePermission(to.name);
      if (perms && need && !perms[need] && to.path !== "/") {
        store.commit("NOTIFICATION_MESSAGE", { status: -1, title: "No permission", message: trf("Your role cannot open that page (needs '{0}').", [need]) });
        next("/");
        return;
      }
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

/**
 * Keep the old Vuex page value in step with the route.
 *
 * This is not leftover plumbing. The analytics overlay that turns one page
 * into Web Analytics is a plain script outside the bundle (public/ga4/panel.js),
 * and it activates by watching store.state.common.location
 * for the value "deal-analytics". Dropping that value would blank a page the
 * owner relies on, so the router publishes it instead.
 *
 * Anything inside the panel should read $route, never this value.
 */
router.afterEach((to) => {
  store.commit("CHAANGE_LOCATION", to.name || "");
});

export default router;
